import { HIDE_MESSAGE, SHOW_MESSAGE } from './actionTypes';
export function showMessageBar(type, message) {
    if(typeof message === 'object') {
        message = message?.response?.data?.message || message.message;
    }
    return dispatch =>
        dispatch({
            type: SHOW_MESSAGE,
            payload: {
                type: type,
                message: message
            }
        })
}
export function hideMessageBar() {
    return dispatch =>
        dispatch({
            type: HIDE_MESSAGE,
            payload: false
        })
}

export function showAppNotifications(payload = { title: "", message: "", image: null, type: "", icon: null }) {
    return dispatch =>
        dispatch({
            type: SHOW_MESSAGE,
            payload
        })
}